import { useQuery } from "@tanstack/react-query";
import { MODULES, type ModuleKey, type Permission } from "@kipo/shared";
import { useTRPC, type RouterOutputs } from "./trpc";

export type Me = RouterOutputs["core"]["me"];

export function useMe() {
  const trpc = useTRPC();
  return useQuery(trpc.core.me.queryOptions(undefined, { staleTime: 60_000 }));
}

export function useCan() {
  const { data } = useMe();
  return (p: Permission) => !!data?.permissions.includes(p);
}

export function useModuleActive() {
  const { data } = useMe();
  return (k: ModuleKey) => !!data?.entitlement.activeModules.includes(k);
}

/** Colore pieno del modulo; Kipo AI è "inchiostro", quindi segue il tema. */
export function moduleColor(key: string): string | undefined {
  return key === "ai" ? "var(--color-ink)" : MODULES[key as ModuleKey]?.color;
}

/**
 * Variabili CSS del modulo: header, accenti e focus prendono il suo colore.
 * Tinta e inchiostro passano dai token del tema, così seguono anche lo scuro.
 */
export function moduleVars(key: ModuleKey | null): React.CSSProperties {
  if (!key) return {};
  const color = key === "ai" ? "var(--color-chrome)" : MODULES[key].color;
  return { ["--module" as string]: color, ["--module-tint" as string]: `var(--color-${key}-tint)`, ["--module-ink" as string]: `var(--color-${key}-ink)` } as React.CSSProperties;
}
